<template>
    <div v-if="webInfo">
        <div class="elementTitle">{{webInfo.WidgetFuture.part1.elementTitle}}</div>
        <div class="elementLabel">{{webInfo.WidgetFuture.part1.elementLabel}}</div>
        <div class="employmentListDiv">
            <el-image lazy style="width: 100%;margin: 30px auto;" :src="globalConfig.filePath + webInfo.WidgetFuture.part1.employmentListBackground" fit="cover"></el-image>
        </div>

        <div class="elementTitle">{{webInfo.WidgetFuture.part2.elementTitle}}</div>
        <div class="elementLabel">{{webInfo.WidgetFuture.part2.elementLabel}}</div>
        <div class="graduateListDiv">
            <div class="graduateListInfo" v-for="(item, index) in webInfo.WidgetFuture.part2.graduateList" :key="index">
                <div v-if="index%2 != 0" class="graduateListText">{{item.text}}</div>
                <el-image style="height: 480px;width: 100%;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                <div v-if="index%2 == 0" class="graduateListText">{{item.text}}</div>
            </div>
        </div>

        <div class="elementTitle">{{webInfo.WidgetFuture.part3.elementTitle}}</div>
        <div class="elementLabel">{{webInfo.WidgetFuture.part3.elementLabel}}</div>
        <div class="cooperationListDiv">
            <el-row :gutter="10" style="margin-top: 15px">
                <el-col class="cooperationList" :span="4" v-for="(item, index) in webInfo.WidgetFuture.part3.cooperationList" :key="index">
                    <el-image lazy style="height: 100%;width: 100%;display: block;" :src="globalConfig.filePath + item" fit="cover"></el-image>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                webInfo: null,
            };
        },
        updated() {},
        mounted() {
            var that = this;
            that.webInfo = that.$parent.webInfo;
        },
        methods: {},
    };
</script>

<style scoped>
    .elementTitle {
        font-size: 32px;
        font-weight: bold;
        line-height: 60px;
        width: 100%;
        text-align: center;
    }

    .elementLabel {
        font-size: 16px;
        line-height: 30px;
        width: 100%;
        text-align: center;
    }

    .employmentListDiv {
        width: 600px;
        margin: 0 auto;
    }

    .graduateListDiv {
        width: 65%;
        margin: 20px auto 50px auto;
        display: flex;
        justify-content: space-between;
    }

    .graduateListDiv >>> img,
    .employmentListDiv {
        transition: 0.3s;
    }

    .graduateListDiv >>> img:hover,
    .employmentListDiv:hover {
        transform: scale(1.1);
    }

    .graduateListInfo {
        width: 25%;
        margin: 0 10px;
        height: 550px;
    }

    .graduateListText {
        height: 70px;
        width: 100%;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        line-height: 70px;
        background-color: #ccc;
    }

    .cooperationListDiv {
        width: 65%;
        margin: 20px auto 50px auto;
    }

    .cooperationList {
        padding: 5px;
        box-sizing: border-box;
    }

    .cooperationList >>> img {
        transition: 0.3s;
    }

    .cooperationList >>> img:hover {
        transform: scale(1.1);
    }
</style>


// WEBPACK FOOTER //
// src/components/Widget/WidgetFuture.vue